var __WEBPACK_NAMESPACE_OBJECT__ = window['aws-xray-sdk'];